import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownTimeout = useRef(null);

  const itemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/arama?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setIsSearchOpen(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion);
    navigate(`/arama?q=${encodeURIComponent(suggestion)}`);
    setSearchQuery('');
    setIsSearchOpen(false);
  };

  const handleMobileMenuClose = () => setIsMobileMenuOpen(false);

  const handleDropdownEnter = () => {
    clearTimeout(dropdownTimeout.current);
    setIsDropdownOpen(true);
  };

  const handleDropdownLeave = () => {
    dropdownTimeout.current = setTimeout(() => setIsDropdownOpen(false), 150);
  };

  return (
    <div className="navbar-sticky-wrapper">

    <div className="announcement-bar">
       Yaz indirimleri başladı! %20 indirim fırsatından hemen yararlanmak için <strong><Link to="/urunler" style={{ textDecoration: 'underline', color: 'white' }}>tıklayın!</Link></strong>
    </div>
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img
            src="https://res.cloudinary.com/dgnhcvmvi/image/upload/w_254,q_auto:good,f_auto/v1783943701/MEBS_254px_da1gio.jpg"
            alt="MEBS İpek Aksesuar"
            className="navbar-logo-img"
            width="254"
            height="254"
            fetchPriority="high"
          />
        </Link>

        {/* Mobile sağ grup: sepet ikonu + hamburger */}
        <div className="mobile-right-group">
          {/* Sepet ikonu (mobile only) */}
          <button
            className="mobile-cart-btn"
            onClick={() => navigate('/sepet')}
            aria-label="Sepete git"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            {itemCount > 0 && (
              <span className="mobile-cart-badge">{itemCount}</span>
            )}
          </button>

          {/* Hamburger Button (mobile only) */}
          <button
            className="hamburger-button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menüyü aç/kapat"
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        {/* Search Section */}
        <div className="navbar-search">
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              placeholder="Ürün ara... (örn: ipek eşarp, şal)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => setIsSearchOpen(true)}
              onBlur={() => setTimeout(() => setIsSearchOpen(false), 200)}
              className="search-input"
            />
            

            {/* Search Suggestions */}
            {isSearchOpen && searchQuery.length > 0 && (
              <div className="search-suggestions">
                <div className="suggestions-title">
                  Hızlı Arama Önerileri:
                </div>
                <div
                  className="suggestion-item"
                  onClick={() => handleSuggestionClick('Eşarp')}
                >
                  🔍 Eşarp
                </div>
                <div
                  className="suggestion-item"
                  onClick={() => handleSuggestionClick('Şal')}
                >
                  🔍 Şal
                </div>
                <div
                  className="suggestion-item"
                  onClick={() => handleSuggestionClick('Fular')}
                >
                  🔍 Fular
                </div>
              </div>
            )}
            <button type="submit" className="search-button">
              🔍
            </button>
          </form>
        </div>

        {/* Mobile overlay */}
        {isMobileMenuOpen && (
          <div className="mobile-overlay" onClick={handleMobileMenuClose}></div>
        )}

        {/* Navigation Menu */}
        <div className={`navbar-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {/* Mobile Search (drawer içinde) */}
          <div className="mobile-search-wrapper">
            <form onSubmit={(e) => { handleSearch(e); handleMobileMenuClose(); }} className="search-form">
              <input
                type="text"
                placeholder="Ürün ara..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
              <button type="submit" className="search-button">🔍</button>
            </form>
          </div>

          <Link to="/" className="nav-link" onClick={handleMobileMenuClose}>
            Ana Sayfa
          </Link>
          <div
            className="nav-dropdown-wrapper"
            onMouseEnter={handleDropdownEnter}
            onMouseLeave={handleDropdownLeave}
          >
            <Link to="/urunler" className="nav-link" onClick={handleMobileMenuClose}>
              Ürünler ▾
            </Link>
            <div className={`nav-dropdown${isDropdownOpen ? ' nav-dropdown-open' : ''}`}>
              <Link to="/urunler?kategori=E%C5%9Farp" className="dropdown-item" onClick={handleMobileMenuClose}>Eşarplar</Link>
              <Link to="/urunler?kategori=%C5%9Eal" className="dropdown-item" onClick={handleMobileMenuClose}>Şallar</Link>
              <Link to="/urunler?kategori=Fular" className="dropdown-item" onClick={handleMobileMenuClose}>Fularlar</Link>
              <Link to="/urunler?kategori=Twilly" className="dropdown-item" onClick={handleMobileMenuClose}>Twilly</Link>
            </div>
          </div>

          {/* Mobile: kategori linkleri dropdown olmadan */}
          <div className="mobile-category-links">
            <Link to="/urunler" className="nav-link" onClick={handleMobileMenuClose}>Tüm Ürünler</Link>
            <Link to="/urunler?kategori=E%C5%9Farp" className="nav-link nav-link-sub" onClick={handleMobileMenuClose}>— Eşarplar</Link>
            <Link to="/urunler?kategori=%C5%9Eal" className="nav-link nav-link-sub" onClick={handleMobileMenuClose}>— Şallar</Link>
            <Link to="/urunler?kategori=Fular" className="nav-link nav-link-sub" onClick={handleMobileMenuClose}>— Fularlar</Link>
            <Link to="/urunler?kategori=Twilly" className="nav-link nav-link-sub" onClick={handleMobileMenuClose}>— Twilly</Link>
          </div>
          <Link to="/sepet" className="nav-link cart-link" onClick={handleMobileMenuClose}>
            Sepet
            {itemCount > 0 && (
              <span className="cart-badge">
                {itemCount}
              </span>
            )}
          </Link>

          {user ? (
            <>
              <Link to="/profil" className="nav-link" onClick={handleMobileMenuClose}>
                Profil
              </Link>

              {user.role === 'admin' && (
                <Link to="/admin" className="nav-link admin-link" onClick={handleMobileMenuClose}>
                  Admin
                </Link>
              )}

              <span className="user-greeting">
                {user.name || user.email}
              </span>

              <button onClick={() => { logout(); handleMobileMenuClose(); }} className="logout-button">
                Çıkış
              </button>
            </>
          ) : (
            <div className="auth-links">
              <Link to="/giris" className="nav-link" onClick={handleMobileMenuClose}>
                Giriş
              </Link>
              <Link to="/kayit" className="nav-link" onClick={handleMobileMenuClose}>
                Kayıt
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
    </div>
  );
}

export default Navbar;
